import UnitManagementComponent from 'components/desktop/StandingData/Unit/Management/UnitManagementComponent';

const UnitArchiveContainer = () => {
	const renderContent = () => {
		return (
			<main className="container">
				<UnitManagementComponent archive={true} />
			</main>
		);
	};

	return <>{renderContent()}</>;
};

export default UnitArchiveContainer;
